import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import './styles/main.css'
import { generateRoutes } from './router'
import { setFromRoute } from './i18n'

export const createApp = ViteSSG(
  App,
  { routes: generateRoutes() },
  ({ router }) => {
    router.beforeEach((to) => {
      setFromRoute(
        (to.meta.langCode as string) || 'he',
        (to.meta.pageId as string) || 'hub'
      )
    })
  }
)
